const initState = {
    isLoading: false,
    data: [],
    error: null,
  };
  
  const PointsReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_POINTS_LOADING":
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      case "SET_POINTS_DATA":
        return {
          ...state,
          isLoading: false,
          data: action.payload,
        };
      case "SET_POINTS_ERROR":
        return {
          ...state,
          isLoading: false,
          data: [],
          error: action.payload,
        };
        case "SET_POINTS_RESET":
        return {
            ...state,
            isLoading: false,
            data: [],
            error: null,
        };
      default:
        return state;
    }
  };
  
  export default PointsReducer;